webpackJsonp([1],{

/***/ "0HKl":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Anatomy_of_a_Script_2x.jpg";

/***/ }),

/***/ "0tvN":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Collaborative_Learning_2x.jpg";

/***/ }),

/***/ "1QkR":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/blog-video_2x.jpg";

/***/ }),

/***/ "1Z0F":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "html/video-gallery_8d05b1e76b1c45e1f15eb0d30de083b6.html";

/***/ }),

/***/ "4c32":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/be_brilliant_video_preview_2x.jpg";

/***/ }),

/***/ "4rgK":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/social_2x.jpg";

/***/ }),

/***/ "53gd":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Mountains_2x.jpg";

/***/ }),

/***/ "9PkT":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/hubspot_preview_2x.jpg";

/***/ }),

/***/ "9eMJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/new-recipe_2x.jpg";

/***/ }),

/***/ "AYrr":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Animatron_Product_Demo_2x.jpg";

/***/ }),

/***/ "Bqs3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Images are stored in app/assets/images/landing/video-previews folder, but here should only be filename.
 * all images should have .jpg extension.
 * add preview image for retina, you need add file with sufix _2x.
 * image size should be 320x180 and for _2x(retina) 640x360
 */

Object.defineProperty(exports, "__esModule", { value: true });
var videos = {
    'h0iARjYhbHY': {
        name: 'Animatron Product Demo'
    },
    'yvKVLFBk7MU': {
        name: 'How To Bait Your Hook'
    },
    '3nvvjdpvVwE': {
        name: 'Anatomy of a Script'
    },
    '0UsaRxqEFnE': {
        name: 'Collaborative Learning'
    },
    '4jtMLJR7YVE': {
        name: 'Animatron - Banner Ad Explainer Video',
        preview: 'Animatron_Explainer_Video'
    },
    'uQ_w0Y8YFJY': {
        name: 'Silent Explainer Video'
    },
    'NU-0qpoD7Yk': {
        name: 'Whiteboard animation',
        preview: 'whiteboard'
    },
    '13mGg5gmPL4': {
        name: 'How to Create Whiteboard Animation with Animatron'
    },
    'TxyPmfybDlw': {
        name: 'Year End Sale Video'
    },
    'rt5_OHiqxbA': {
        name: 'A Promo Video for an Online Teacher',
        preview: 'Teacher_demo'
    },
    '5lmn5G2SM1Q': {
        name: 'Promo video',
        preview: 'Brooklyn'
    },
    'nL8KXi-Ebpg': {
        name: 'Short ads',
        preview: 'short_ads'
    },
    'Hsb8Hnxnyyw': {
        name: 'Social media videos',
        preview: 'social'
    },
    '4ZNaLnVaGj8': {
        name: 'Event promo video',
        preview: 'Wine'
    },
    'Vm_W4CX72rw': {
        name: 'Website Promo',
        preview: 'Mountains'
    },
    '8Rq75fMP8v8': {
        name: 'Real Estate Ad',
        preview: 'Real_Estate'
    },
    'UjmaE78NyB4': {
        name: 'Bakery Promo Video',
        preview: 'Bakery'
    },
    'LhyXWD-Ua-w': {
        name: 'Fashion',
        preview: 'Fashion'
    },
    'pw4b7fmh5u': {
        preview: 'like_croissants',
        name: 'Marketing videos and advertising',
    },
    'isujvqsudd': {
        preview: 'house_preview',
        name: 'Promotions',
    },
    'twoktydxrp': {
        preview: 'truffaldino',
        name: 'Event announcements'
    },
    'ic81et8wgb': {
        preview: 'style_up',
    },
    '8u7dsisbi7': {
        preview: 'bang_club',
    },
    'nexuabrmwe': {
        preview: 'fusilli',
    },
    'trppod8rcb': {
        preview: 'chelsea',
    },
    '3ci2sswcd4': {
        preview: 'market_listing',
    },
    '6nuk3l0wnk': {
        preview: 'blog-video',
    },
    'yrg8tmhc1o': {
        preview: 'new-recipe',
    },
    '139fa2vsci': {
        preview: 'success_preview_2_981',
        name: 'Customer Reviews',
    },
    'h5zebqa72w': {
        preview: 'success_preview_3_981',
        name: 'Customer Reviews',
    },
    'a5sb1vfe2e': {
        preview: 'success_preview_1_981',
        name: 'Promo Video',
    },
    'm6f026jfzb': {
        preview: 'be_brilliant_video_preview',
    },
    'mv1bxlqob1': {
        preview: 'hubspot_cover'
    },
    'pcte5apcav': {
        preview: 'hubspot_preview'
    },
    'jupk7hpj85': {
        preview: 'thanksgiving_offer'
    },
    'n95b2k3sl1': {
        preview: 'wistia_preview'
    }
};
var VideoGallery = (function () {
    function VideoGallery() {
        this.videos = this.getVideos();
        this.player = this.player || 'youtube';
        this.viewMode = this.viewMode || 'border';
    }
    VideoGallery.prototype.getPreviewUrl = function (fileName) {
        try {
            return __webpack_require__("mioT")("./" + fileName + "_2x.jpg");
        }
        catch (e) {
            _.notification.showError(e);
            console.error(e);
            return '';
        }
    };
    VideoGallery.prototype.getVideos = function () {
        return this.videosIds.map(function (videoId) {
            var v = videos[videoId];
            if (v) {
                return Object.assign({}, v, {
                    videoId: videoId,
                    preview: v.preview || v.name.replace(/ /g, '_')
                });
            }
            else {
                return { videoId: videoId };
            }
        });
    };
    return VideoGallery;
}());
exports.VideoGallery = VideoGallery;
angular.module('animatronApp.videoGallery', [])
    .component('videoGallery', {
    bindings: {
        videosIds: '<',
        viewMode: '@',
        player: '@'
    },
    controller: VideoGallery,
    templateUrl: __webpack_require__("1Z0F")
});


/***/ }),

/***/ "CLPB":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Teacher_demo_2x.jpg";

/***/ }),

/***/ "CdUx":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/chelsea_2x.jpg";

/***/ }),

/***/ "DbF/":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/thanksgiving_offer_2x.jpg";

/***/ }),

/***/ "EJJq":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Real_Estate_2x.jpg";

/***/ }),

/***/ "EY2t":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/truffaldino_2x.jpg";

/***/ }),

/***/ "FXBL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Fashion_2x.jpg";

/***/ }),

/***/ "IaFL":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/hubspot_cover_2x.jpg";

/***/ }),

/***/ "IzYH":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/like_croissants_2x.jpg";

/***/ }),

/***/ "JBeu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Wine_2x.jpg";

/***/ }),

/***/ "PqOi":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/whiteboard_2x.jpg";

/***/ }),

/***/ "R2Pv":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Whiteboard_short_explainer_2x.jpg";

/***/ }),

/***/ "R7d8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/looking_for_house_2x.jpg";

/***/ }),

/***/ "RCsF":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/short_ads_2x.jpg";

/***/ }),

/***/ "TJrD":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Year_End_Sale_Video_2x.jpg";

/***/ }),

/***/ "UD7f":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Bakery_2x.jpg";

/***/ }),

/***/ "WpQJ":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/success_preview_2_981_2x.jpg";

/***/ }),

/***/ "bAkP":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/house_preview_2x.jpg";

/***/ }),

/***/ "cbpy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/bang_club_2x.jpg";

/***/ }),

/***/ "hMDX":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Silent_Explainer_Video_2x.jpg";

/***/ }),

/***/ "irt1":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/How_to_Create_Whiteboard_Animation_with_Animatron_2x.jpg";

/***/ }),

/***/ "j6f8":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/market_listing_2x.jpg";

/***/ }),

/***/ "kr3B":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/success_preview_3_981_2x.jpg";

/***/ }),

/***/ "ktG4":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/How_To_Bait_Your_Hook_2x.jpg";

/***/ }),

/***/ "m8uy":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Animatron_Explainer_Video_2x.jpg";

/***/ }),

/***/ "mioT":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./Anatomy_of_a_Script_2x.jpg": "0HKl",
	"./Animatron_Explainer_Video_2x.jpg": "m8uy",
	"./Animatron_Product_Demo_2x.jpg": "AYrr",
	"./Bakery_2x.jpg": "UD7f",
	"./Brooklyn_2x.jpg": "wvc0",
	"./Collaborative_Learning_2x.jpg": "0tvN",
	"./Fashion_2x.jpg": "FXBL",
	"./How_To_Bait_Your_Hook_2x.jpg": "ktG4",
	"./How_to_Create_Whiteboard_Animation_with_Animatron_2x.jpg": "irt1",
	"./Mountains_2x.jpg": "53gd",
	"./Real_Estate_2x.jpg": "EJJq",
	"./Silent_Explainer_Video_2x.jpg": "hMDX",
	"./Teacher_demo_2x.jpg": "CLPB",
	"./Whiteboard_short_explainer_2x.jpg": "R2Pv",
	"./Wine_2x.jpg": "JBeu",
	"./Year_End_Sale_Video_2x.jpg": "TJrD",
	"./bang_club_2x.jpg": "cbpy",
	"./be_brilliant_video_preview_2x.jpg": "4c32",
	"./blog-video_2x.jpg": "1QkR",
	"./chelsea_2x.jpg": "CdUx",
	"./house_preview_2x.jpg": "bAkP",
	"./hubspot_cover_2x.jpg": "IaFL",
	"./hubspot_preview_2x.jpg": "9PkT",
	"./like_croissants_2x.jpg": "IzYH",
	"./looking_for_house_2x.jpg": "R7d8",
	"./market_listing_2x.jpg": "j6f8",
	"./new-recipe_2x.jpg": "9eMJ",
	"./short_ads_2x.jpg": "RCsF",
	"./social_2x.jpg": "4rgK",
	"./success_preview_1_981_2x.jpg": "uQXu",
	"./success_preview_2_981_2x.jpg": "WpQJ",
	"./success_preview_3_981_2x.jpg": "kr3B",
	"./thanksgiving_offer_2x.jpg": "DbF/",
	"./truffaldino_2x.jpg": "EY2t",
	"./whiteboard_2x.jpg": "PqOi"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "mioT";

/***/ }),

/***/ "uQXu":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/success_preview_1_981_2x.jpg";

/***/ }),

/***/ "wvc0":
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "images/landing/video-previews/Brooklyn_2x.jpg";

/***/ })

});


// WEBPACK FOOTER //
// javascripts/1-28dc41a6a889e793a2e2.min.js